import React, { useRef } from 'react';
import { useScroll } from 'framer-motion';
import { AnimatedTriangles } from './AnimatedTriangles';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start start', 'end end']
  });
  return <div ref={containerRef} className="min-h-screen w-full bg-[#042854] text-white font-sans selection:bg-[#a1da52] selection:text-[#042854] overflow-x-hidden" data-id="element-97">
      {/* Animated Triangles Background */}
      <AnimatedTriangles scrollProgress={scrollYProgress} data-id="element-98" />

      {/* Content */}
      <div className="relative z-10 flex flex-col min-h-screen" data-id="element-99">{children}</div>
    </div>;
}